import { defineComponent as _defineComponent } from 'vue'
import { ApiPostLoadStatus, ApiPostLoadStatusType } from "@/modules/types/apiLoadStatusType";
import ApiErrorDisplay from "./ApiErrorDisplay.vue";
import ApiLoadingDisplay from "./ApiLoadingDisplay.vue";

interface Props {
	/**
	 * APIステータス。
	 */
	status: ApiPostLoadStatusType;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    status: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * APIステータス。
	 */
	status: ApiPostLoadStatusType;
}
/**
 * POSTリクエストでの、APIローディング表示コンテンツ。
 */


const __returned__ = { props, ApiPostLoadStatus, ApiErrorDisplay, ApiLoadingDisplay }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})